export const TITLE = "biblio";
export const MAIN_COLOR = "#EE0072";
export const SECOND_COLOR = "#FF0000";